/* eslint-disable */

import Flickity from 'flickity'

export default magazineSlider => {
  const leftArrow = $(magazineSlider).find('.js-carousel-left')
  const rightArrow = $(magazineSlider).find('.js-carousel-right')

  if (magazineSlider) {
    const flkty = new Flickity(magazineSlider, {
      contain: true,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: false
    })

    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    setTimeout(() => {
      flkty.resize()
    }, 1500)
    $(leftArrow).click(() => flkty.previous())
    $(rightArrow).click(() => flkty.next())
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/mobile-magazine-slider.js